export default __webpack_public_path__ + "static/media/photo12.963b759f.jpg";